
import type { TFunction } from 'i18next';

import { CrudMode, FormItem, transformUppercaseNoSpaces } from '@ohpen/enso-ui';
import type { RenderFormItem } from '@ohpen/enso-ui';
import { DEFAULT_TEXT_MAX_LENGTH_SHORT, textLimitProps } from '@pmp/utils';

export const getFormSchema = (
  t: TFunction,
  renderErcBands: RenderFormItem<{ index: number }>,
  renderAlert: RenderFormItem<{ index: number }>,
  mode?: CrudMode | null,
  isUsed?: boolean | null,
): FormItem[] => {
  const disabled = mode === CrudMode.VIEW || isUsed;

  return [
    {
      renderFormItem: renderAlert,
    },
    {
      title: 'pmp.erc.labels.ercProfileId',
      dataIndex: 'ercProfileId',
      fieldProps: {
        disabled: mode !== CrudMode.CREATE,
        ...textLimitProps(DEFAULT_TEXT_MAX_LENGTH_SHORT),
      },
      formItemProps: {
        required: true,
        getValueFromEvent: transformUppercaseNoSpaces,
      },
    },
    {
      title: 'pmp.erc.labels.ercProfileName',
      dataIndex: 'name',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled: mode === CrudMode.VIEW,
        ...textLimitProps(DEFAULT_TEXT_MAX_LENGTH_SHORT),
      },
    },
    {
      title: 'pmp.erc.labels.rollingOrFixed',
      dataIndex: 'rollingOrFixed',
      valueType: 'select',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled,
        options: [
          { label: t('pmp.erc.labels.rolling'), value: false },
          { label: t('pmp.erc.labels.fixed'), value: true },
        ],
        defaultValue: false,
        allowClear: false,
      },
    },
    {
      title: 'pmp.erc.labels.ercBands',
      dataIndex: 'penaltyTiers',
      renderFormItem: renderErcBands,
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled,
      },
    },
  ];
};
